import { NEW_API_URL } from '@karma/utils/constants/env';
import { cookieUtilsForLp, getCookieValue, removeCookie, setCookie } from 'functions/cookies';
import CConsole from 'functions/CConsole';
import { newApiInstance } from 'functions/request';
import { ITEMS as LOCAL_STORAGE_ITEMS } from 'consts/localStorage';
import isValidUrl from 'functions/isValidUrl';
import { WEEK_IN_MILLISECONDS } from 'consts/time';

export const getMarketingParams = () => {
  return {
    ref_src: localStorage.getItem('ref_src'),
    gclid: localStorage.getItem('gclid'),
    referral_src: localStorage.getItem('referral_src') || localStorage.getItem('ref_src'),
    referral_code: localStorage.getItem('referral_code'),
    referer_id: localStorage.getItem('referer_id'),
    referer_list_id: localStorage.getItem('referer_list_id'),
    uid_token: localStorage.getItem('uid_token'),
    campaign: localStorage.getItem('campaign'),
    campaign_full_url: localStorage.getItem('campaign_full_url'),
    sub_campaign: localStorage.getItem('sub_campaign'),
    session_id: getCookieValue('sessionId'),
    lp_test: localStorage.getItem(LOCAL_STORAGE_ITEMS.lpTest),
    utm_source: getCookieValue('utm_source'),
    utm_medium: getCookieValue('utm_medium'),
    utm_content: getCookieValue('utm_content'),
    utm_term: getCookieValue('utm_term'),
    utm_campaign: getCookieValue('utm_campaign'),
  };
};

export const clearMarketingParams = () => {
  Object.keys(getMarketingParams()).forEach(param => {
    localStorage.removeItem(param);
    removeCookie(param);
  });
};

export const processMarketingParams = async (customHref = '') => {
  const href = customHref && isValidUrl(customHref) ? customHref : window.location.href;
  const url = new URL(href);
  const campaignFullUrl = localStorage.getItem('campaign_full_url');
  const marketingParamsUpdatedAtString = localStorage.getItem('marketing_params_updated_at');
  const marketingParamsUpdatedAt = marketingParamsUpdatedAtString ? Number(marketingParamsUpdatedAtString) : null;
  const now = Date.now();

  // if less than 2 weeks have passed since the last update, ignore it
  if (marketingParamsUpdatedAt && now - marketingParamsUpdatedAt < WEEK_IN_MILLISECONDS * 2) return;
  // if this is not the first site visit, but the url does not have marketing parameters, ignore it
  if (campaignFullUrl && !url.searchParams.keys().some(k => k.includes('utm_') || k === 'ref_src')) return;

  // clear old values before saving new ones
  clearMarketingParams();

  localStorage.setItem('marketing_params_updated_at', String(now));
  localStorage.setItem('campaign_full_url', href);

  if (url.searchParams.get('utm_source')) setCookie('utm_source', url.searchParams.get('utm_source'));
  if (url.searchParams.get('utm_medium')) setCookie('utm_medium', url.searchParams.get('utm_medium'));
  if (url.searchParams.get('utm_content')) setCookie('utm_content', url.searchParams.get('utm_content'));
  if (url.searchParams.get('utm_term')) setCookie('utm_term', url.searchParams.get('utm_term'));
  if (url.searchParams.get('utm_campaign')) setCookie('utm_campaign', url.searchParams.get('utm_campaign'));
  if (url.searchParams.get('utm_source') === 'rp') {
    setCookie('utm_campaign', url.searchParams.get('sid'));
    setCookie('sid', url.searchParams.get('sid'));
  }
  if (url.searchParams.get('sessionId')) setCookie('sessionId', url.searchParams.get('sessionId'));
  if (url.searchParams.get('ref_src')) localStorage.setItem('ref_src', url.searchParams.get('ref_src'));

  await newApiInstance
    .get(`/referral_links/user${url.search}`)
    .then(response => {
      Object.keys(response.data || {}).forEach(param => {
        const refValue = response.data[param];

        if (param && refValue) localStorage.setItem(param, refValue);
      });
    })
    .catch(CConsole.error);
};

export const processMarketingParamsForLp = () => {
  return `
    (function processMarketingParamsForLp() {
      ${cookieUtilsForLp()}
      
      function getMarketingParams() {
        return {
          ref_src: localStorage.getItem('ref_src'),
          gclid: localStorage.getItem('gclid'),
          referral_src: localStorage.getItem('referral_src') || localStorage.getItem('ref_src'),
          referral_code: localStorage.getItem('referral_code'),
          referer_id: localStorage.getItem('referer_id'),
          referer_list_id: localStorage.getItem('referer_list_id'),
          uid_token: localStorage.getItem('uid_token'),
          campaign: localStorage.getItem('campaign'),
          campaign_full_url: localStorage.getItem('campaign_full_url'),
          sub_campaign: localStorage.getItem('sub_campaign'),
          session_id: getCookieValue('sessionId'),
          lp_test: localStorage.getItem('lp_test'),
          utm_source: getCookieValue('utm_source'),
          utm_medium: getCookieValue('utm_medium'),
          utm_content: getCookieValue('utm_content'),
          utm_term: getCookieValue('utm_term'),
          utm_campaign: getCookieValue('utm_campaign'),
        };
      };

      function clearMarketingParams() {
        Object.keys(getMarketingParams()).forEach(param => {
          localStorage.removeItem(param);
          removeCookie(param);
        });
      };
    
      const WEEK_IN_MILLISECONDS = 604800000;
      const url = new URL(window.location.href);
      const campaignFullUrl = localStorage.getItem('campaign_full_url');
      const marketingParamsUpdatedAtString = localStorage.getItem('marketing_params_updated_at');
      const marketingParamsUpdatedAt = marketingParamsUpdatedAtString ? Number(marketingParamsUpdatedAtString) : null;
      const now = Date.now();
    
      if (marketingParamsUpdatedAt && now - marketingParamsUpdatedAt < WEEK_IN_MILLISECONDS * 2) return;
      if (campaignFullUrl && !url.searchParams.keys().some(k => k.includes('utm_') || k === 'ref_src')) return;
    
      clearMarketingParams();
    
      localStorage.setItem('marketing_params_updated_at', String(now));
      localStorage.setItem('campaign_full_url', window.location.href);
    
      if (url.searchParams.get('utm_source')) setCookie('utm_source', url.searchParams.get('utm_source'));
      if (url.searchParams.get('utm_medium')) setCookie('utm_medium', url.searchParams.get('utm_medium'));
      if (url.searchParams.get('utm_content')) setCookie('utm_content', url.searchParams.get('utm_content'));
      if (url.searchParams.get('utm_term')) setCookie('utm_term', url.searchParams.get('utm_term'));
      if (url.searchParams.get('utm_campaign')) setCookie('utm_campaign', url.searchParams.get('utm_campaign'));
      if (url.searchParams.get('utm_source') === 'rp') {
        setCookie('utm_campaign', url.searchParams.get('sid'));
        setCookie('sid', url.searchParams.get('sid'));
      }
      if (url.searchParams.get('sessionId')) setCookie('sessionId', url.searchParams.get('sessionId'));
      if (url.searchParams.get('ref_src')) localStorage.setItem('ref_src', url.searchParams.get('ref_src'));
    
      fetch('${NEW_API_URL}/referral_links/user' + url.search)
        .then(response => response.json())
        .then(data => {
          Object.keys(data || {}).forEach(param => {
            const refValue = data[param];
  
            if (param && refValue) localStorage.setItem(param, refValue);
          });
        })
        .catch(console.error);
    })();
  `;
};
